"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationFromSeconds = exports.DurationFromSecondsBounds = exports.makeDurationFromMillis = void 0;
const effect_1 = require("effect");
const NAMESPACE = 'Time';
const makeDurationFromMillis = (...args) => effect_1.Schema.Literal(...args)
    .pipe(effect_1.Schema.compose(effect_1.Schema.DurationFromMillis), effect_1.Schema.filter(duration => args.some((0, effect_1.flow)(effect_1.Duration.millis), effect_1.Duration.equals(duration))))
    .annotations({
    arbitrary: () => FC => FC.constantFrom(...args).map(effect_1.Duration.millis),
});
exports.makeDurationFromMillis = makeDurationFromMillis;
exports.DurationFromSecondsBounds = { min: 0 };
exports.DurationFromSeconds = effect_1.Schema.transformOrFail(effect_1.Schema.DurationFromMillis.from.pipe(effect_1.Schema.greaterThanOrEqualTo(exports.DurationFromSecondsBounds.min)), effect_1.Schema.DurationFromMillis, {
    strict: true,
    decode: seconds => effect_1.Effect.succeed(effect_1.Number.multiply(seconds, 1_000)),
    encode: millis => effect_1.Number.divide(millis, 1_000).pipe(effect_1.Effect.mapError(() => new effect_1.ParseResult.Unexpected(millis))),
}).annotations({ identifier: `${NAMESPACE}.DurationFromSeconds` });
//# sourceMappingURL=time.js.map